import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import loaders from './loaders'
import getLang from './getLang'

Vue.use(VueI18n)
const lang = getLang()
const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'en',
  messages: {},
  silentTranslationWarn: true,
})
ElementLocale.i18n((key, value) => i18n.t(key, value))
export { i18n }
const loadedLanguages = ['en'] 

function setI18nLanguage(lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

function generateHandler(module_name) {
  return function (modules) {
    if (!modules.length) return
    let messages = {}
    modules.forEach(item => {
      messages = { ...messages, ...item.default }
    })
    i18n.setLocaleMessage(lang, { ...messages, ...i18n.messages[lang] })
    loadedLanguages.push(module_name)
    return setI18nLanguage(lang)
  }
}

export function loadLanguageAsync(name) {
  const module_name = `${name}_${lang}`
  if (!loadedLanguages.includes(module_name)) {
    const loader = loaders[module_name]
    if (!loader) return
    return loader(generateHandler(module_name))
  }
  return Promise.resolve(setI18nLanguage(lang))
}



// WEBPACK FOOTER //
// ./resources/js/lib/i18n/index.js